/*
 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2023-07-06 15:03:14
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2024-01-18 14:55:35
 * @FilePath: \xm-runing-main\src\components\xm-tenant-and-industry-toggle\stores\xm-tenant-select.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { DropdownProps, MenuProps } from 'ant-design-vue'
import { useSwitchTenant } from '@/layouts/default/header/components/hooks/useSwitchTenant'
import { defHttp } from 'xmgoing-server'
import { useXmTenantDropdownStore } from './xm-tenant-dropdown'
import {onMounted} from "vue";
import {StorageUtils} from 'xmgoing-utils';
import {dbUtils} from 'xmgoing-utils';

export const useXmIndustryDropdownStore = defineStore('xm-industry-dropdown', () => {
  const XmTenantDropdownStore = useXmTenantDropdownStore()
  const { _loginSuccess: loginSuccess  } = useSwitchTenant();

  const {
    currentTitle
  } = storeToRefs(XmTenantDropdownStore)

  const dropdownProps = computed<DropdownProps>(() => {
    return {
      placement: 'bottomRight',
    }
  })

  /**
   * 菜单选中项
   */
  const selectedKeys:any = ref([]);

  const menuProps = computed<MenuProps>(() => {
    return {
      selectable: true,
      selectedKeys: selectedKeys.value,
    }
  })

  const loading = ref(false)

  /**
   * 点击进行切换操作
   * @param selectedKeys
   */
  const onSelect: MenuProps['onSelect'] = ({selectedKeys}) => {
    StorageUtils.addSessionItem("curIndustryId",selectedKeys.at(0));
    switchIndustry(selectedKeys.at(0))
  }

  //行业切换操作
  async function switchIndustry (industryId: string) {
    loading.value = true
    try {
      const res = await defHttp.post({
        url: '/pe-portal/tenantIndustryType/user/switchIndustry',
        data: {
          tenantId: industryId
        }
      })
      console.log(res)

      dbUtils.clearUserMenus()

      nextTick(() => {
        loginSuccess(res);
      })
    } finally {
      loading.value = false
    }
  }

  watch(currentTitle, (title) => {
    console.log(title)
  })

  /**
   * 初始化行业显示菜单
   * @param list
   */
  const initCurIndustrySelId=async function (list){
    const res = await defHttp.get({
      url: '/pe-portal/users/getIndustryTenantId',
      data: {}
    })
    const curSelItem=list.filter((itemDb)=>{
      return itemDb.tenantId===res;
    })[0];
    if(curSelItem){
      unref(selectedKeys).push(curSelItem.tenantId)
    }
  }

  /**
   * 获取行业切换的列表集合
   */
  const industryList = ref<{value: string, label: string, title: string}[]>([])
  //获取行业切换列表
  async function getIndustryList () {
    loading.value = true;
    try {
      const list = await defHttp.get({
        url: '/pe-portal/tenantIndustryType/user/listByCurrentAccount',
        params: {}
      })
      industryList.value=list;
      if(list&&list.length>0){
        initCurIndustrySelId(list);
      }
    } finally {
      loading.value = false
    }
  }

  onMounted(getIndustryList)
  return {
    menuProps,
    dropdownProps,
    industryList,
    onSelect,
    loading
  }
})
